import React from "react";
import style from "./style.module.scss";
import { FaSpinner } from 'react-icons/fa';

const Button = props => {
  const { children, size, color, loading = false, disabled = false, className = "" } = props;
  return (
    <button
      {...props}
      type="button"
      className={`${className} ${style.button}`}
      data-size={size}
      data-color={color}
      disabled={loading || disabled}
    >
      {!loading ? (
        children
      ) : (
        <FaSpinner color="#fff" className={style._loading} />
      )}
    </button>
  )
}

export default Button;